import React from 'react';
import { TextInputBaseWrapper } from '../internal/components/TextInputWrapper.js';
import { clsx } from 'clsx';
import classes from './TextArea.module.css.js';
import { jsx } from 'react/jsx-runtime';

const DEFAULT_TEXTAREA_ROWS = 7;
const DEFAULT_TEXTAREA_COLS = 30;
const DEFAULT_TEXTAREA_RESIZE = 'both';
/**
 * An accessible, native textarea component that supports validation states.
 * This component accepts all native HTML <textarea> attributes as props.
 */
const Textarea = /*#__PURE__*/React.forwardRef(({
  value,
  disabled,
  sx: sxProp,
  required,
  validationStatus,
  rows = DEFAULT_TEXTAREA_ROWS,
  cols = DEFAULT_TEXTAREA_COLS,
  resize = DEFAULT_TEXTAREA_RESIZE,
  block,
  contrast,
  className,
  ...rest
}, ref) => {
  return /*#__PURE__*/jsx(TextInputBaseWrapper, {
    sx: sxProp,
    validationStatus: validationStatus,
    disabled: disabled,
    block: block,
    contrast: contrast,
    className: className,
    children: /*#__PURE__*/jsx("textarea", {
      value: value,
      "data-resize": resize,
      "aria-required": required,
      "aria-invalid": validationStatus === 'error' ? 'true' : 'false',
      ref: ref,
      disabled: disabled,
      rows: rows,
      cols: cols,
      className: clsx(classes.TextArea, className),
      ...rest
    })
  });
});
Textarea.displayName = 'Textarea';

export { DEFAULT_TEXTAREA_COLS, DEFAULT_TEXTAREA_RESIZE, DEFAULT_TEXTAREA_ROWS, Textarea as default };
